// Gear.js
import React from 'react';

function Gear({ language, content }) {
  return (
    <section id="gear" className="gear-section">
      <div className="gear-ovals-angled-container">
        <div className="gear-oval-angled oval1">
          {/* Text goes in the top oval for better visibility */}
          <h3>{content.gearTitle}</h3>
          <ul>
            {content.gearItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="gear-oval-angled oval2">
          {/* This oval is mostly for visual overlap */}
        </div>
      </div>
    </section>
  );
}

export default Gear;